import React, { useState } from 'react';
import { Button, Grid, Select, Space, Spin, Table, Tag } from 'antd';
import useRouteQuery from '../../../../../../../Utils/useRouterQuery';
import { SelectOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import {
  useCheckInvoices,
  useCompanyData,
  useGetHistorySubscription,
  useRenewInvoice,
} from '../../../../../../../Hooks/TT_ELD/Companies';
import moment from 'moment';
import { getUserFromLocalStorage } from '../../../../../../../Utils/sidebar';

type numStr = string | number;

type MyObjectType = {
  [key: string | number]: any;
};

interface approvalSource {
  no: numStr;
  id: numStr;
  amount: string;
  status: numStr;
  createdAt: numStr;
  action: { id: numStr; note: string; companyId: numStr; status: numStr };
  key: React.Key;
}

const { useBreakpoint } = Grid;

const { Option } = Select;
type params = {
  readonly id: any;
};
const statusList = [
  {
    label: 'Paid',
    value: 'paid',
  },

  {
    label: 'Unpaid',
    value: 'open',
  },
];
type Data = {
  data?: {
    data: any;
    nextPageExist: boolean;
  };
  isLoading?: boolean;
  refetch?: any;
  isFetching?: boolean;
};

const SubscriptionUpdate = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const userString = localStorage.getItem('user');
  let userConfig: Record<string, any> = {};

  try {
    const parsed = JSON.parse(userString || '{}');
    userConfig = parsed?.config || {};
  } catch {}

  const canSeeStripeData =
    userConfig['read_companies-stripe-management'] === true &&
    userConfig['write_companies-stripe-management'] === true;

  const [previousButtonClicked, setPreviousButtonClicked] = useState(false);
  const [status, setStatus] = useRouteQuery('paid', 'status', (v) => String(v));
  const [skip, setSkip] = useState<string>('1');
  const { id } = useParams<params>();
  const [getCompanyId, setCompanyId] = useState<string | number | undefined>();
  const company: MyObjectType = useCompanyData(id);
  const { mutate: renewInvoice, isLoading: isRenewingInvoice }: MyObjectType = useRenewInvoice();
  const [next, setNext] = useState<object>({ value: false, lastInvoiceId: '' });
  const checkInvoices: MyObjectType = useCheckInvoices(getCompanyId);
  const { data, refetch, isLoading, isFetching }: Data = useGetHistorySubscription(
    status,
    next,
    id,
  );
  const onChange = (query: any) => {
    setSkip(query.current);
  };
  const handleCheckInvoices = () => {
    setCompanyId(id);
    checkInvoices?.refetch();
  };
  const [currentPage, setCurrentPage] = useState(0);
  const currentUserRole = getUserFromLocalStorage()?.role || '';
  const isManager = String(currentUserRole)
    .trim()
    .toLowerCase() === 'manager';

  const editCurrentPage = (prev: boolean) => {
    if (prev) {
      setNext({ value: false, lastInvoiceId: data?.data[0]?.id });
      setCurrentPage((val) => val - 1);
      setPreviousButtonClicked(prev);
    } else {
      setNext({ value: true, lastInvoiceId: data?.data[data?.data.length - 1]?.id });
      setCurrentPage((val) => val + 1);
      setPreviousButtonClicked(prev);
    }
  };
  const columns: object[] = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      sorter: {
        compare: (a: any, b: any) => a.no - b.no,
        multiple: 1,
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (tag: string) => (
        <Tag color={tag === 'paid' ? 'green' : 'red'}>{tag?.toUpperCase()}</Tag>
      ),
    },

    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      width: 300,
      // fixed: 'right',
      render: ({
        id: invoiceId,
        note,
        companyId,
        status,
      }: {
        id: string | number;
        note: string;
        companyId: string | number;
        status: string | number;
      }) => {
        const isUnpaidInvoice = String(status || '')
          .trim()
          .toLowerCase() === 'open';
        const canRenderRenewButton = isUnpaidInvoice && isManager;
        return (
          <Space size={8}>
            <Link target="_blank" to={note}>
              <Button type="primary">
                Open Invoice <SelectOutlined rev={undefined} />
              </Button>
            </Link>
            {canRenderRenewButton && (
              <Button
                onClick={() =>
                  renewInvoice(
                    {
                      invoiceId: String(invoiceId),
                      companyId: String(companyId),
                    },
                    {
                      onSuccess: () => {
                        refetch?.();
                      },
                    },
                  )
                }
                loading={isRenewingInvoice}
              >
                Renew
              </Button>
            )}
          </Space>
        );
      },
    },
  ];
  return (
    <div className="mainPage">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          marginBottom: 10,
          flexWrap: 'wrap',
        }}
      >
        {/* Desktop: status chapda */}
        {!isMobile && (
          <Select
            value={status ? status : 'all'}
            defaultValue="pending"
            onChange={(value: any) => {
              setStatus(value === 'all' ? '' : value);
              setSkip('1');
            }}
            style={{ width: 200 }}
          >
            {statusList.map((u: any, index: any) => (
              <Option key={index} value={u.value}>
                {u.label}
              </Option>
            ))}
          </Select>
        )}

        <Space
          size={10}
          style={{
            marginLeft: 'auto',
            width: isMobile ? '100%' : 'auto',
            justifyContent: isMobile ? 'space-between' : 'flex-end',
            display: 'flex',
          }}
        >
          <Button
            type="primary"
            size="large"
            onClick={() => handleCheckInvoices()}
            disabled={!canSeeStripeData}
            style={{ flex: isMobile ? 1 : 'unset' }}
          >
            Check Invoices
          </Button>

          <Button size="large" onClick={refetch} style={{ flex: isMobile ? 1 : 'unset' }}>
            Refresh
          </Button>
        </Space>

        {isMobile && (
          <Select
            value={status ? status : 'all'}
            defaultValue="pending"
            onChange={(value: any) => {
              setStatus(value === 'all' ? '' : value);
              setSkip('1');
            }}
            style={{ width: '100%' }}
          >
            {statusList.map((u: any, index: any) => (
              <Option key={index} value={u.value}>
                {u.label}
              </Option>
            ))}
          </Select>
        )}
      </div>
      <Spin size="large" spinning={isLoading || isFetching}>
        <Table
          style={{ margin: '15px 0 15px 0' }}
          onChange={onChange}
          dataSource={data?.data.map((u: any, i: number): approvalSource => {
            const invoiceAmount = u.total < 0 ? '-' : `$${Math.abs(u.total) / 100}`;
            const formattedDate2 = moment
              .unix(u.created)
              .tz(company.data?.tz?.value)
              .format('MMMM Do YYYY, h:mm:ss a');

            const obj: approvalSource = {
              no: currentPage * 10 + i + 1,
              id: u.id,
              amount: invoiceAmount,
              status: u.status,
              createdAt: formattedDate2,
              action: { id: u.id, note: u.hosted_invoice_url, companyId: id, status: u.status },
              key: u.id,
            };
            return obj;
          })}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <span
          style={{
            display: 'flex',
            margin: '15px 0 0px 0',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            style={{ margin: '0px 15px 0px 0' }}
            disabled={currentPage === 0}
            onClick={() => editCurrentPage(true)}
          >
            Previous
          </Button>
          <Button
            disabled={!(previousButtonClicked || data?.nextPageExist)}
            onClick={() => editCurrentPage(false)}
          >
            Next
          </Button>
        </span>
      </Spin>
    </div>
  );
};

export default SubscriptionUpdate;
